import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';
import Payment, { ShopProduct } from '../../../interfaces/Payment';

import { StripeElementCard } from '@vue-stripe/vue-stripe';

@Component({
  template: require('./checkout-page-stripe.html'),

  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
    'stripe-element-card': StripeElementCard,
  },
})
export class CheckoutPageStripe extends vue {
  data = {
    checked : false,
  };
  $refs: {
    elementRef: any;
  }
  publishableKey = process.env.STRIPE_PK;
  paymentSuccess:any = '';
  paymentError = '';
  successMessage = '';
  couponForm = {
    input: '',
    success: '',
    error: '',
  }
  product: ShopProduct = null;
  // coupon code that has been validated by the server for this product
  appliedCoupon = '';
  // amount returned by POST /coupons/check (decimal string), replaces product.price as the amount to pay
  couponAmount = '';
  couponDiscount = '';
  // set after an unconfirmed payment (502): the user must not retry from the UI
  paymentLocked = false;
  description = '';
  paymentStatus = false;
  productName = '';
  buttonText = '';
  paymentsProvider = IocContainer.get < Payment > (SERVICES.PAYMENT);

  async mounted() {
    const type = this.$route.params.product;
    let products: ShopProduct[] = [];
    try {
      products = await this.paymentsProvider.getProducts();
    } catch (e) {
      products = [];
    }
    let product: ShopProduct = null;
    if (type === 'extend') {
      this.buttonText = 'Extend Course';
      product = products.find(el => el.type === 'extension' && el.days === Number(this.$route.params.days));
    } else if (type === 'upgrade') {
      this.buttonText = 'Upgrade Course';
      product = products.find(el => el.type === 'upgrade' && el.course_id === Number(this.$route.params.selectedCourse));
    } else if (type === 'practicum') {
      this.buttonText = 'Buy Practicum';
      product = products.find(el => el.type === 'practicum');
    }
    if (!product) {
      this.$router.push('/');
      return;
    }
    this.product = product;
    this.productName = product.type === 'upgrade' ? 'Upgrade course to ' + product.name : product.name;
    this.description = product.description;
    this.paymentStatus = true;
  }
  // Preloader
  get loading() {
    return this.paymentStatus || this.paymentSuccess;
  }
  get user() {
    return this.$store.getters.user;
  }
  get userProgress() {
    return this.$store.state.progress;
  }
  get lessonsData() {
    return this.$store.state.lessons;
  }

  get currencyLabel() {
    return this.product ? this.product.currency.toUpperCase() : '';
  }

  get totalPrice(): number {
    return this.product ? Number(this.product.price) : 0;
  }

  get discountedPrice(): number {
    return this.appliedCoupon ? Number(this.couponDiscount) : 0;
  }

  get amountToPay(): number {
    return this.appliedCoupon ? Number(this.couponAmount) : this.totalPrice;
  }

  async applyCoupon() {
    this.couponForm.success = '';
    this.couponForm.error = '';
    this.appliedCoupon = '';
    this.couponAmount = '';
    this.couponDiscount = '';
    const code = this.couponForm.input.trim();
    if (code.length === 0) {
      this.couponForm.error = 'Please enter coupon code before apply';
      return;
    }
    try {
      const result = await this.paymentsProvider.checkCoupon(this.product.id, code);
      if (result.success) {
        this.appliedCoupon = code;
        this.couponAmount = result.amount;
        this.couponDiscount = result.discount;
        this.couponForm.success = 'Your coupon has been applied';
      } else {
        this.couponForm.error = result.message || 'Coupon code is not valid for this product';
      }
    } catch (e) {
      this.couponForm.error = this.errorMessage(e, 'Coupon code is not valid for this product');
    }
  }

  errorMessage(e, fallback: string): string {
    if (e && e.response && e.response.data && e.response.data.message) {
      return e.response.data.message;
    }
    return fallback;
  }

  async tokenCreated(token) {
    this.paymentStatus = false;
    window.scroll(0, 0);
    this.paymentError = '';
    try {
      const result = await this.paymentsProvider.pay(this.product.id, token.id, this.appliedCoupon || undefined);
      if (!result.success) {
        this.paymentError = result.message || 'Payment could not be completed.';
        this.paymentStatus = true;
        return;
      }
      this.successMessage = result.message;
      this.paymentSuccess = true;
      try {
        await this.afterPayment();
      } catch (afterError) {
        // the payment succeeded; a failed reload must not turn it into an error state
        console.error(afterError);
      }
    } catch (e) {
      this.paymentError = this.errorMessage(e, 'Server error');
      // 502: the charge may or may not have gone through - do not invite a retry
      if (e && e.response && e.response.status === 502) {
        this.paymentLocked = true;
      }
    }
    this.paymentStatus = true;
  }

  async afterPayment() {
    if (this.product.type === 'upgrade') {
      // upgrade user progress
      let progress = [...this.userProgress];
      await this.$store.dispatch('loadUser');
      await this.$store.dispatch('loadCourse');
      //need to put flag listener to course load
      setTimeout(() => {
        progress.forEach((p) => {
          const lesson = this.lessonsData.find(l => l.id === p.id && l.type === p.type);
          if (lesson) {
            p.orderBlock = lesson.orderBlock;
          }
        });
        this.$store.dispatch('saveProgress', progress);
      }, 3000);
    } else {
      await this.$store.dispatch('loadUser');
    }
  }

  makePayment() {
    if (this.paymentLocked) {
      return;
    }
    this.data.checked = false;
    this.$refs.elementRef.submit();
  }
}
